export default function slugify(val: string) {
  return encodeURIComponent(
    val
      .toLowerCase()
      .normalize("NFD") // breaks out accents from base characters
      .trim()
      .replace(/\s+/g, "-") // turn spaces into hyphens
      .replace(/[^a-z0-9-]/g, "") // remove all other special characters
  );
}
